import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/styles";
import EmptyImgStatus from "components/EmptyState/EmptyImageStatus";
import LoadingComponent from "components/LoadingComponent/LoadingComponent";
import { parseCustomDomainUrl } from "features/helpers/utils";
import ContractItem from "./ContractItem";
import useGetPagePermission from "hooks/useGetPagePermission";
import useAnalyticsModule from "hooks/useAnalyticsModule";
import _ from "lodash";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useOutletContext } from "react-router-dom";

const DappActivityTrackingSettingContent = ({
  dataList,
  loading,
  onDelete,
}) => {
  const [entityName, isCustomDomain] = useOutletContext();
  const { attributionConnect } = useAnalyticsModule();
  const theme = useTheme();

  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const [noResult, setNoResult] = useState(true);
  const pagePermission = useGetPagePermission();
  // const { canEdit } = pagePermission("webTraffic");// TODO 是否有permission的限制

  const handleToSetTracking = (targetId, row) => {
    navigate(
      parseCustomDomainUrl(
        isCustomDomain,
        entityName,
        `/settings/general/integration/attribution?from=analytics/settings/website-traffic`
      )
    );
  };

  const handleToCreateObjective = () => {
    navigate(
      parseCustomDomainUrl(
        isCustomDomain,
        entityName,
        `/analytics/settings/dapp-activity-tracking/add-contract`
      )
    );
  };

  const renderDataList = () => {
    if (loading) {
      return (
        <Box
          height={"60vh"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <LoadingComponent></LoadingComponent>
        </Box>
      );
    }

    return (
      <Grid container spacing={2} className="fade-up-more" alignItems="stretch">
        {_.map(dataList, (contractItem) => (
          <Grid xs={12} sm={6} md={4} item key={contractItem._id}>
            <ContractItem contractInfo={contractItem} />
          </Grid>
        ))}
        {dataList.length === 0 && (
          <Grid xs={12} sm={6} md={4} item>
            <Box
              sx={{
                height: "214px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: `1px dashed ${theme.customColors.purple[500]}`,
                color: theme.customColors.purple[500],
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: 700,
                cursor: "pointer",
              }}
              onClick={handleToCreateObjective}
            >
              + {formatMessage({ id: "global.btn.addContract" })}
            </Box>
          </Grid>
        )}
      </Grid>
    );
  };

  return <>{renderDataList()}</>;
};

export default DappActivityTrackingSettingContent;
